import React from "react";
import "./InfoIcon.css";

function InfoIcon({infoText, icon, extraClass, count}: {infoText: string, count ?: number, extraClass ?: string, icon: React.ReactNode}) {
    if (count !== undefined) {
        return <span
            aria-hidden="true"
            title={infoText}
            style={{ display: 'inline-flex', alignItems: 'center' }}

        >
            <div className={"info-count-pill " + (extraClass ? extraClass : "")}>
                <div className="info-count">{count}</div>
                <div className="info-icon">{icon}</div>
            </div>
    </span>
    }
    return <span
        aria-hidden="true"
        title={infoText}
        style={{ display: 'inline-flex', alignItems: 'center' }}
    >
      {icon}
    </span>
}

export default InfoIcon;